const server = {
  pro: 'https://api.changbi.com/',
  dev: 'https://api.changbi.com/',
  util: 'https://api.changbi.com/',
};
// http://192.168.3.14:8000/
var DOMIN = 'https://api.changbi.com/';
// var DOMIN = 'http://43.200.43.9:8000/';
// var DOMIN = 'http://3.37.128.178:8000/'; // 복제 운영계 api;

// const origin = location.hostname;
// for (var i in server) {
//   var item = server[i];
//   if (item.indexOf(origin) > -1) {
//     DOMIN = item;
//   }
// }

if (!DOMIN) DOMIN = '/api';
export default {
  DOMIN,
};
